<template>
  <span class="block-chongdianzhuang">
    <div class="list-data">
      <div class="col">
        <div>{{data.chargingPileDataList[0].name}}</div>
        <div class="bk">
          <span class="wrap">
          <div class="desc">今日充电量</div>
          <div>
            <span class="number">{{data.chargingPileDataList[0].dailyEnergy}}</span>
            <span class="unit">kWh</span>
          </div>
          </span>
        </div>
        <div class="bk">
          <span class="wrap">
          <div class="desc">累计充电量</div>
          <div>
            <span class="number">{{data.chargingPileDataList[0].totalEnergy}}</span>
            <span class="unit">kWh</span>
          </div>
          </span>
        </div>
      </div>
      <div class="col">
        <div>{{data.chargingPileDataList[1].name}}</div>
        <div class="bk">
          <span class="wrap">
          <div class="desc">今日充电量</div>
          <div>
            <span class="number">{{data.chargingPileDataList[1].dailyEnergy}}</span>
            <span class="unit">kWh</span>
          </div>
          </span>
        </div>
        <div class="bk">
          <span class="wrap">
          <div class="desc">累计充电量</div>
          <div>
            <span class="number">{{data.chargingPileDataList[1].totalEnergy}}</span>
            <span class="unit">kWh</span>
          </div>
          </span>
        </div>
      </div>
      <div class="col">
        <div>{{data.chargingPileDataList[2].name}}</div>
        <div class="bk">
          <span class="wrap">
          <div class="desc">今日充电量</div>
          <div>
            <span class="number">{{data.chargingPileDataList[2].dailyEnergy}}</span>
            <span class="unit">kWh</span>
          </div>
          </span>
        </div>
        <div class="bk">
          <span class="wrap">
          <div class="desc">累计充电量</div>
          <div>
            <span class="number">{{data.chargingPileDataList[2].totalEnergy}}</span>
            <span class="unit">kWh</span>
          </div>
          </span>
        </div>
      </div>
    </div>
    <div class="echart-data">
      <EchartsLineThree eid="cdz" :data="data.echartsData"></EchartsLineThree>
    </div>
  </span>
</template>

<script>
import * as echarts from 'echarts';
import EchartsLineThree from  './echarts-line-three.vue'
export default {
  components:{
    EchartsLineThree
  },
  props: {
    data: {
      type: Object
    },
    echartsData:{
      type:Object,
      default(){
        return {
          xLabel: ['03:00', '06:00', '09:00', '12:00', '15:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00'],
          xValue: [
            [120, 132, 101, 134, 90, 230, 210, 182, 191, 234, 290, 330],
            [220, 182, 191, 234, 290, 330, 310, 201, 154, 190, 330, 410],
            [150, 232, 201, 154, 190, 330, 410,150, 232, 201, 154, 190]
          ]
        }
      }
    }
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {

  }
};
</script>

<style lang="scss">
.block-chongdianzhuang {
  position: relative;
  top: 0px;
  width: 100%;
  height: 100%;
  display: inline-block;
  z-index: 99;
  .echart-data{
    width: 100%;
    height: 150px;
  }
  .list-data {
    display: flex;
    justify-content: space-around;
    .col {
      font-size: 12px;
      font-family: DINBold, DINAlternate;
      font-weight: bold;
      color: #08265f;
      width: 117px;
      height: 130px;
      &:nth-child(1) {
        background: url('/static/images/svolt/nanwang/cd-line-01.png') no-repeat;
        background-size: 100% 8px;
        background-position-y: 14px;
        div.bk:nth-child(2) {
          margin-top: 10px;
          width: 100%;
          height: 47px;
          text-align: center;
          background: linear-gradient(180deg, rgba(255,255,255,0.23) 0%, rgba(239,165,68,0.23) 100%);
          .wrap{
            display: inline-block;
            margin-top: 8px;
            .desc{
              display: inline-block;
              font-size: 12px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #5E688F;
              margin-top: 2px;
            }
            .number{
              font-size: 20px;
              margin-top: 2px;
              color: #08265F;
              font-family: DINBold, DINAlternate;
            }
            .unit{
              display: inline-block;
              font-size: 12px;
              margin-top: 2px;
              color: #08265F;
            }
          }
        }
        div.bk:nth-child(3) {
          margin-top: 10px;
          width: 100%;
          height: 47px;
          text-align: center;
          background: linear-gradient(180deg, rgba(255,255,255,0.23) 0%, rgba(239,165,68,0.23) 100%);
          .wrap{
            display: inline-block;
            margin-top: 8px;
            .desc{
              display: inline-block;
              font-size: 12px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #5E688F;
              margin-top: 2px;
            }
            .number{
              font-size: 20px;
              margin-top: 2px;
              color: #08265F;
              font-family: DINBold, DINAlternate;
            }
            .unit{
              display: inline-block;
              font-size: 12px;
              margin-top: 2px;
              color: #08265F;
            }
          }
        }
      }
      &:nth-child(2) {
        background: url('/static/images/svolt/nanwang/cd-line-02.png') no-repeat;
        background-size: 100% 8px;
        background-position-y: 14px;
        div.bk:nth-child(2) {
          margin-top: 10px;
          width: 100%;
          height: 47px;
          text-align: center;
          background: linear-gradient(180deg, rgba(255,255,255,0.23) 0%, rgba(144,226,243,0.23) 100%);
          .wrap{
            display: inline-block;
            margin-top: 8px;
            .desc{
              display: inline-block;
              font-size: 12px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #5E688F;
              margin-top: 2px;
            }
            .number{
              font-size: 20px;
              margin-top: 2px;
              color: #08265F;
              font-family: DINBold, DINAlternate;
            }
            .unit{
              display: inline-block;
              font-size: 12px;
              margin-top: 2px;
              color: #08265F;
            }
          }
        }
        div.bk:nth-child(3) {
          margin-top: 10px;
          width: 100%;
          height: 47px;
          text-align: center;
          background: linear-gradient(180deg, rgba(255,255,255,0.23) 0%, rgba(144,226,243,0.23) 100%);
          .wrap{
            display: inline-block;
            margin-top: 8px;
            .desc{
              display: inline-block;
              font-size: 12px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #5E688F;
              margin-top: 2px;
            }
            .number{
              font-size: 20px;
              margin-top: 2px;
              color: #08265F;
              font-family: DINBold, DINAlternate;
            }
            .unit{
              display: inline-block;
              font-size: 12px;
              margin-top: 2px;
              color: #08265F;
            }
          }
        }
      }
      &:nth-child(3) {
        background: url('/static/images/svolt/nanwang/cd-line-03.png') no-repeat;
        background-size: 100% 8px;
        background-position-y: 14px;
        div.bk:nth-child(2) {
          margin-top: 10px;
          width: 100%;
          height: 47px;
          text-align: center;
          background: linear-gradient(180deg, rgba(255,255,255,0.23) 0%, rgba(150,197,255,0.23) 100%);
          .wrap{
            display: inline-block;
            margin-top: 8px;
            .desc{
              display: inline-block;
              font-size: 12px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #5E688F;
              margin-top: 2px;
            }
            .number{
              font-size: 20px;
              margin-top: 2px;
              color: #08265F;
              font-family: DINBold, DINAlternate;
            }
            .unit{
              display: inline-block;
              font-size: 12px;
              margin-top: 2px;
              color: #08265F;
            }
          }
        }
        div.bk:nth-child(3) {
          margin-top: 10px;
          width: 100%;
          height: 47px;
          text-align: center;
          background: linear-gradient(180deg, rgba(255,255,255,0.23) 0%, rgba(150,197,255,0.23) 100%);
          .wrap{
            display: inline-block;
            margin-top: 8px;
            .desc{
              display: inline-block;
              font-size: 12px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #5E688F;
              margin-top: 2px;
            }
            .number{
              font-size: 20px;
              margin-top: 2px;
              color: #08265F;
              font-family: DINBold, DINAlternate;
            }
            .unit{
              display: inline-block;
              font-size: 12px;
              margin-top: 2px;
              color: #08265F;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/block-chongdianzhuang.vue